var app_archived_campaigns_form = $('#app-archived-campaigns-form');

if (app_archived_campaigns_form.length) {
    var data_table_order = [6, "desc"];
    $(document).ready(function () {
        if (archive_year_initial !== null && archive_year_initial !== 'null')
            var currentYear = archive_year_initial.archive_year;
        else
            var currentYear = (new Date).getFullYear();

    });
    if (archive_year_initial !== null && archive_year_initial !== 'null')
        var currentYear = archive_year_initial.archive_year;
    else
        var currentYear = (new Date).getFullYear();

    initializeCampaignsArchivedTable(currentYear);
    function initializeCampaignsArchivedTable(file, update) {
        if (update == 1) {
            $('#year_archived_campaign a').each(function () {
                if ($(this).attr('id') == file) {
                    $(this).parent().addClass('currentclass');
                    $(this).addClass('currentclass');
                    $(this).parent().removeClass('cssmenu');
                    $(this).removeClass('cssmenu');
                } else {
                    $(this).parent().removeClass('currentclass');
                    $(this).removeClass('currentclass');
                    $(this).parent().addClass('cssmenu');
                    $(this).addClass('cssmenu');
                }
            });
        }

        var advertiser_id = $('#app-campaigns-table-archived').attr('data-advertiser');
        var advertiser_slug = $('#app-campaigns-table-archived').attr('data-advertiser-slug');
        var has_order = 0;
        var url = '/campaigns/archived/' + advertiser_id + '/' + file;
        $('#app-campaigns-table-archived').DataTable({
            ajax: {
                url: url,
                dataSrc: 'data',
            },
            order: data_table_order,
            columns: [
                {data: 'orders'},//0
                {data: 'name'},//1
                {data: 'date_range'},//2
                {data: 'brand'},//3
                {data: 'product'},//4
                {data: 'budget'},
                {data: 'created_at'},
                {data: 'created_by_name'},
                {data: 'created_at_format'},
                {data: 'slug'}
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log(cellData);
                        var orders = cellData.split('_');
                        if (orders[1] == '')
                            has_order = 1;
                        else
                            has_order = 0;
                        var html = ' <div class="checkbox checkbox-danger campaigns_check_ar"> <input class="checkbox" class="form-control" type="checkbox"  id="' + orders[0] + '" name="selected_campaigns[]" value="' + orders[0] + '" ><label for="' + orders[0] + '"> </label></div>';

                        $(td).html(html);
                    }
                },
                {
                    "targets": 3,
                    "orderable": false,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = (typeof rowData.brand !== 'undefined' && rowData.brand !== null) ? rowData.brand : '';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 4,
                    "orderable": false,
                    "visible": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = (typeof rowData.product !== 'undefined' && rowData.product !== null) ? rowData.product : '';
                        $(td).html(html);
                    }
                },
                {
                    "targets": 5,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html('$ ' + cellData.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                    }
                },
                {
                    "targets": 6,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        $(td).html(date.format('MM/DD/YYYY'));
                    }
                },
                {
                    "targets": 8,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        //  date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        // $(td).html(date.format('MM/DD/YYYY  h:mm A'));
                    }
                },
                {
                    "targets": 9,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {

                        var html = '<a  href="javascript:void(0)" role="button" class="btn btn-success btn-sm" onclick="activateCampaign(\'/campaign/activate_camp/' + cellData + '/activate\')">' +
                            '<i class="ti-check"></i> Activate' +
                            '</a>';
                        html += '<a href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm" onclick="deleteAdvertiserCampaignArchivate(\'/advertisers/' + advertiser_slug + '/archivated/' + cellData + '/destroy\', ' + has_order + ')">' +
                            '<i class="fa fa-trash-o"></i> Delete' +
                            '</a>';


                        html += '</div></div>';
                        $(td).html(html);
                    }
                }
            ]
        });
        $('#app-campaigns-table-archived').on('length.dt', function (e, settings, len) {
            user_entries = len;
        });
        $('#app-campaigns-table-archived').on('order.dt', function (e, settings, len) {
            data_table_order = [len[0].col, "" + len[0].dir + ""];
        });

    }

    $('#year_archived_campaign a').on('click', function () {

        $('#year_archived_campaign a').each(function () {
            if ($(this).attr('current') == 'yes') {
                $(this).parent().removeClass('currentclass');
                $(this).removeClass('currentclass');
                $(this).parent().addClass('cssmenu');
                $(this).addClass('cssmenu');
            }
        });

        $('#current_year').html('Archived Campaigns ' + $(this).attr('id'));
        var url = $(this).attr('data-target');
        var advertiser = $('#app-campaigns-table-archived').attr('data-advertiser-slug');
        var has_order = 0;
        // $('#app-campaigns-table-archived').DataTable({
        //               ajax: {
        //                   url: url,
        //                   dataSrc: 'data',
        //               },
        //             order: data_table_order,
        //             columns: [
        //                 {data: 'orders'},
        //                 {data: 'name'},
        //                 {data: 'date_range'},
        //                 {data: 'brand'},
        //                 {data: 'product'},
        //                 {data: 'budget'},
        //                 {data: 'created_at'},
        //                 {data: 'last_accessed'},
        //                 {data: 'slug'}
        //             ],
        //             destroy: true,
        //               pageLength: user_entries,
        //             "columnDefs": [
        //                 {
        //                     "targets": 0,
        //                     "orderable": false,
        //                     "createdCell": function (td, cellData, rowData, row, col) {
        //                         console.log(cellData);
        //                         var orders= cellData.split('_');
        //                         if(orders[1]=='')
        //                             has_order=1;
        //                         else
        //                             has_order=0;
        //                             var html = ' <div class="checkbox checkbox-danger campaigns_check_ar"> <input class="checkbox" class="form-control" type="checkbox"  id="' + orders[0] + '" name="selected_campaigns[]" value="' + orders[0] + '" ><label for="'+orders[0]+'"> </label></div>';
        //
        //                         $(td).html(html);
        //                     }
        //                 },
        //                 {
        //                     "targets": 5,
        //                     "orderable": false,
        //                     "createdCell": function (td, cellData, rowData, row, col) {
        //                         $(td).html('$ ' + cellData.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
        //                     }
        //                 },
        //                 {
        //                     "targets": 6,
        //                     "orderable": true,
        //                     "createdCell": function (td, cellData, rowData, row, col) {
        //                         date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
        //                         $(td).html(date.format('MM/DD/YYYY'));
        //                     }
        //                 },
        //                 {
        //                     "targets": 7,
        //                     "orderable": true,
        //                     "createdCell": function (td, cellData, rowData, row, col) {
        //                         date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
        //                         $(td).html(date.format('MM/DD/YYYY  h:mm A'));
        //                     }
        //                 },
        //                 {
        //                     "targets": 8,
        //                     "orderable": false,
        //                     "createdCell": function (td, cellData, rowData, row, col) {
        //                         var html =  '<a  href="javascript:void(0)" role="button" class="btn btn-success btn-sm" onclick="activateCampaign(\'/campaign/activate_camp/'+ cellData + '/activate\')">' +
        //                             '<i class="ti-check"></i> Activate' +
        //                             '</a>';
        //
        //                             html+=   '<a  href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm" onclick="deleteAdvertiserCampaignArchivate(\'/advertisers/' + advertiser + '/archivated/'+ cellData + '/destroy\', '+has_order+')">' +
        //                                 '<i class="fa fa-trash-o"></i> Delete' +
        //                                 '</a>';
        //
        //
        //                         html+='</div></div>';
        //                         $(td).html(html);
        //                     }
        //                 }
        //             ]
        //         });
        $('#app-campaigns-table-archived').DataTable({
            ajax: {
                url: url,
                dataSrc: 'data',
            },
            order: data_table_order,
            columns: [
                {data: 'orders'},
                {data: 'name'},
                {data: 'date_range'},
                {data: 'brand'},
                {data: 'product'},
                {data: 'budget'},
                {data: 'created_at'},
                {data: 'created_by_name'},
                {data: 'created_at_format'},
                {data: 'slug'}
            ],
            destroy: true,
            pageLength: user_entries,
            "columnDefs": [
                {
                    "targets": 0,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        console.log(cellData);
                        var orders = cellData.split('_');
                        if (orders[1] == '')
                            has_order = 1;
                        else
                            has_order = 0;
                        var html = ' <div class="checkbox checkbox-danger campaigns_check_ar"> <input class="checkbox" class="form-control" type="checkbox"  id="' + orders[0] + '" name="selected_campaigns[]" value="' + orders[0] + '" ><label for="' + orders[0] + '"> </label></div>';

                        $(td).html(html);
                    }
                },
                {
                    "targets": 5,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        $(td).html('$ ' + cellData.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
                    }
                },
                {
                    "targets": 6,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        $(td).html(date.format('MM/DD/YYYY'));
                    }
                },
                {
                    "targets": 8,
                    "orderable": true,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        //  date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                        // $(td).html(date.format('MM/DD/YYYY  h:mm A'));
                    }
                },
                {
                    "targets": 9,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {

                        var html = '<a  href="javascript:void(0)" role="button" class="btn btn-success btn-sm" onclick="activateCampaign(\'/campaign/activate_camp/' + cellData + '/activate\')">' +
                            '<i class="ti-check"></i> Activate' +
                            '</a>';
                        html += '<a href="javascript:void(0)"  role="button" class="btn btn-danger btn-sm" onclick="deleteAdvertiserCampaignArchivate(\'/advertisers/' + advertiser + '/archivated/' + cellData + '/destroy\', ' + has_order + ')">' +
                            '<i class="fa fa-trash-o"></i> Delete' +
                            '</a>';


                        html += '</div></div>';
                        $(td).html(html);
                    }
                }
            ]
        });
        $('#app-campaigns-table-archived').on('length.dt', function (e, settings, len) {
            user_entries = len;
        });
        $('#app-campaigns-table-archived').on('order.dt', function (e, settings, len) {
            data_table_order = [len[0].col, "" + len[0].dir + ""];
        });
    });
    $('#select_all_camp_a').on('click', function (e) {
        $('#app-campaigns-table-archived input:checkbox').prop('checked', true);
    });
    $('#deselect_all_camp_a').on('click', function (e) {
        $('#app-campaigns-table-archived input:checkbox').prop('checked', false);
    });

    //Activate Campaign Archived
    function activateCampaign(urlVar) {
        $('#activateCampWarningDiv').html('Are you sure to activate this campaign?');
        $('#activateCampConfirm').attr('data-url', urlVar)
        $('#activateCampConfirm').show();
        $('#activateCampMultConfirm').hide();
        $('#activateCampWarningModal').modal('show');
    }
    function activateCampConfirm(){
        show_loader();
        var urlVar = $('#activateCampConfirm').attr('data-url');
        $.ajax({
            url: urlVar,
            success: function (response) {
                global_notification('success', 'Campaign activated...');
                initializeCampaignsArchivedTable(response, 0);
                initializeCampaignsTable();
                $('#activateCampWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    }
    $('#activate_camp_multiple').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        $('.campaigns_check_ar input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length > 0) {
            $('#activateCampWarningDiv').html('Are you sure to activate the selected campaigns?');
            $('#activateCampMultConfirm').attr('data-url', url)
            $('#activateCampMultConfirm').show();
            $('#activateCampConfirm').hide();
            $('#activateCampWarningModal').modal('show');
        } else {
            $('#generalWarningModalDiv').html('Select at least one Campaign.');
            $('#generalWarningModal').modal('show');
        }
    });
    function activateCampMultConfirm() {
        show_loader();
        var url = $('#activateCampMultConfirm').attr('data-url');
        var selectedItems = [];
        $('.campaigns_check_ar input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            campaigns: selectedItems,
        };
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: url,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Campaigns activated...');
                initializeCampaignsArchivedTable(response, 0);
                initializeCampaignsTable();
                $('#activateCampWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    }

    //Delete Campaign Archived table
    function deleteAdvertiserCampaignArchivate(urlVar, hav_order) {
        if (hav_order == 0)
            var mess = "This campaign has created orders. Are you sure to delete?";
        else
            var mess = "Are you sure to delete this campaign?";

        $('#deleteCampWarningDiv').html(mess);
        $('#deletedCampConfirm').attr('data-url', urlVar)
        $('#deletedCampConfirm').show();
        $('#deletedCampMultConfirm').hide();
        $('#deleteCampWarningModal').modal('show');
    }
    function deletedCampConfirm() {
        show_loader();
        var urlVar = $('#deletedCampConfirm').attr('data-url');
        $.ajax({
            url: urlVar,
            success: function (response) {
                global_notification('success', 'Campaigns deleted...');
                initializeCampaignsArchivedTable(response.year, 0);
                $('#deleteCampWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    }
    $('#delete_multiple_camp_a').on('click', function (e) {
        var url = $(this).attr('data-url');
        var selectedItems = [];
        $('.campaigns_check_ar input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        if (selectedItems.length > 0) {
            show_loader();
            var url_one = '/adv/has_order/multiple_delete/confirm/archivated';
            var params = {
                campaigns: selectedItems,
            };
            $.ajax({
                type: 'POST',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: JSON.stringify(params),
                url: url_one,
                dataType: "json",
                contentType: "application/json",
                success: function (response) {
                    hide_loader();
                    if (response.length > 0) {
                        if (selectedItems.length > 1)
                            var mess = 'Some selected campaigns has created orders. Are you sure to delete?';
                        else
                            var mess = 'The selected campaign has created orders. Are you sure to delete?';
                    } else
                        var mess = "Are you sure to delete the selected campaigns?";

                    $('#deleteCampWarningDiv').html(mess);
                    $('#deletedCampMultConfirm').attr('data-url', url)
                    $('#deletedCampMultConfirm').show();
                    $('#deletedCampConfirm').hide();
                    $('#deleteCampWarningModal').modal('show');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);

                }
            });
        } else {
            $('#generalWarningModalDiv').html('Select at least one Campaign.');
            $('#generalWarningModal').modal('show');
        }
    });
    function deletedCampMultConfirm() {
        show_loader();
        var urlVar = $('#deletedCampMultConfirm').attr('data-url');
        var selectedItems = [];
        $('.campaigns_check_ar input[type=checkbox]').each(function () {
            if (this.checked)
                selectedItems.push($(this).val());
        });
        var params = {
            campaigns: selectedItems,
        };
        console.log(urlVar);
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: urlVar,
            dataType: "json",
            contentType: "application/json",
            success: function (response) {
                global_notification('success', 'Campaigns deleted.');
                initializeCampaignsArchivedTable(response.year, 0);
                $('#deleteCampWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);

            }
        });
    }
}
